module.exports = __webpack_public_path__ + "img/bguate.df853418.png";